export default __webpack_public_path__ + "static/media/add-test-disabled.da4b934f.svg";